module.exports = __webpack_public_path__ + "assets/remind.2e293506.svg";